export default {
  title: "Couldn't find what you are looking for? We'll design it for you!",
  subTitle:
    "If you need a scientific illustration, image, drawing, or icon that is not yet available in our gallery, you can request it, and we'll create it for you. Follow these steps:",
  stepOne: (
    <>
      {' '}
      Go to the workspace and click the “Request an Illustration” button, at the bottom-left of your
      screen.
    </>
  ),
  stepTwo: (
    <>
      Fill in the form with the details about the scientific illustration you need. You may also
      attach references, like hand drawings and other images.
    </>
  ),
  stepThree: (
    <>
      Your request should take around 7 working days to be ready. You'll receive na email when the
      scientific illustration is available.
    </>
  ),
  text: 'You can also request an illustration now clicking the button below',
  textButton: 'Request an illustration Now',
};
